module.exports = __webpack_public_path__ + "static/media/logo_wbs_gruppe.5fe7cb58.svg";